const ENTITIES = {
  amp: '&',
  apos: "'",
  '#x27': "'",
  '#x2F': '/',
  '#39': "'",
  '#47': '/',
  lt: '<',
  gt: '>',
  nbsp: ' ',
  quot: '"'
};
export const decodeHTML = (text = '') => text.replace(/&([^;]+);/gm, (match, entity) => ENTITIES[entity] || match);